import {
    Combobox,
    ComboboxContent,
    ComboboxEmpty,
    ComboboxInput,
    ComboboxItem,
    ComboboxList,
} from "@/components/ui/combobox";
import { PersonAvatar } from "../avatar/PersonAvatar";

export type AgentPickerItem = {
    id: string;
    name: string;
    firstName?: string;
};

export function AgentPicker({
    id,
    items,
    value,
    onChange,
    placeholder = "Search agents",
    positionerClassName,
}: {
    id?: string;
    items: AgentPickerItem[];
    value: string;
    onChange: (agent: AgentPickerItem) => void;
    placeholder?: string;
    positionerClassName?: string;
}) {
    const selected = items.find((agent) => agent.id === value) ?? null;

    return (
        <Combobox
            autoHighlight
            items={items}
            value={selected}
            onValueChange={(agent) => {
                if (agent) onChange(agent);
            }}
            itemToStringLabel={(agent) => agent.name}
            isItemEqualToValue={(a, b) => a.id === b.id}
            filter={agentMatchesQuery}
        >
            <ComboboxInput
                id={id}
                placeholder={placeholder}
                showTrigger
                className="w-full"
            />
            <ComboboxContent positionerClassName={positionerClassName}>
                <ComboboxEmpty>No agents match</ComboboxEmpty>
                <ComboboxList>
                    {(agent: AgentPickerItem) => (
                        <ComboboxItem key={agent.id} value={agent}>
                            <PersonAvatar
                                name={agent.name}
                                kind="agent"
                                id={agent.id}
                                className="size-6"
                            />
                            <span className="min-w-0 flex-1 truncate">
                                {agent.name}
                            </span>
                        </ComboboxItem>
                    )}
                </ComboboxList>
            </ComboboxContent>
        </Combobox>
    );
}

function agentMatchesQuery(agent: AgentPickerItem, query: string): boolean {
    const term = query.trim().toLowerCase();
    return (
        term.length === 0 ||
        agent.name.toLowerCase().includes(term) ||
        (agent.firstName?.toLowerCase().includes(term) ?? false)
    );
}
